import { useState } from 'react';
import ArtistRow from './ArtistRow';
import ArtistVotersModal from './ArtistVotersModal';
import { rowSizeForArtist } from '../../utils/lineupFormat';
import { useEventLineup, useLineupMutualVoters } from '../../hooks/queries/useEventLineup';

/**
 * Shared-interest visibility for regular events (read-only, no matching):
 * per lineup artist, which of the viewer's mutual follows voted for that
 * artist at this event. Renders nothing when there is no overlap.
 */
export default function MutualVotersPanel({ eventId, userId, className = '' }) {
  const { data: lineup = [] } = useEventLineup(eventId);
  const { data: votersByArtist = {} } = useLineupMutualVoters(eventId, userId);
  const [openArtist, setOpenArtist] = useState(null);

  const seen = new Set();
  const rows = lineup.filter((row) => {
    if (seen.has(row.artist_id)) return false;
    seen.add(row.artist_id);
    return (votersByArtist[row.artist_id] || []).length > 0;
  });

  if (rows.length === 0) return null;

  return (
    <div className={`lineup-glass-card p-3 ${className}`}>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-ink/50">
        Friends into this lineup
      </p>
      <div className="space-y-1">
        {rows.map((row) => (
          <ArtistRow
            key={row.artist_id}
            artist={row}
            size={rowSizeForArtist(row)}
            layout="group"
            voters={votersByArtist[row.artist_id]}
            onPress={setOpenArtist}
          />
        ))}
      </div>

      <ArtistVotersModal
        artist={openArtist}
        voters={openArtist ? votersByArtist[openArtist.artist_id] || [] : []}
        viewerId={userId}
        context="mutual"
        onClose={() => setOpenArtist(null)}
      />
    </div>
  );
}
